<section class="after-santion-wrap">
  <div class="wrap-lg">
    <div class="after-santion-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="gotoHome()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 6L9 12L15 18"
              stroke="#1A204B"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <!-- <div class="page-title">{{title}}</div> -->
          <div class="page-info">{{conntent}}</div>
        </div>
      </div>
      <div class="box-tab">
        <div class="tab-sec">
          <div class="page-steps">
            STEP
            <span class="count">{{ steps }} / 3</span>
          </div>
          <div class="primary-tab after-santion-tab">
            <div class="tab-item" [class.active]="tabs == 'key-fact-statement'">
              Key Fact Statement
              <img class="input-icon" *ngIf="!loanDetains.isKfsNotComplete" [src]="tickImage" alt="Icon" />
            </div>
            <div class="tab-item" [class.active]="tabs == 'application-letter'">
              Application Letter
              <img class="input-icon" *ngIf=" loanDetains.eSigned && !loanDetains.isAfNotComplete && loanDetains.applicationFormConfirmation" [src]="tickImage" alt="Icon" />
            </div>
            <div class="tab-item" [class.active]="tabs == 'nach-mandate'">
              NACH Mandate <img class="input-icon" *ngIf="loanDetains.overallConfirmation && !loanDetains.isPNACHNotComplete" [src]="tickImage" alt="Icon" />
            </div>
          </div>
          <div class="color"></div>
        </div>
        <div class="tab-content1">
          <app-key-fact-statement
            *ngIf="tabs == 'key-fact-statement'"
          ></app-key-fact-statement>
          <app-application-letter
            *ngIf="tabs == 'application-letter'"
          ></app-application-letter>
          <app-nach-mandate *ngIf="tabs == 'nach-mandate'"></app-nach-mandate>
        </div>
      </div>
    </div>
  </div>
</section>
